import { render, staticRenderFns } from "./GreetingsEditor.vue?vue&type=template&id=548e0ed2&"
import script from "./GreetingsEditor.vue?vue&type=script&lang=js&"
export * from "./GreetingsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('548e0ed2')) {
      api.createRecord('548e0ed2', component.options)
    } else {
      api.reload('548e0ed2', component.options)
    }
    module.hot.accept("./GreetingsEditor.vue?vue&type=template&id=548e0ed2&", function () {
      api.rerender('548e0ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/GreetingsEditor.vue"
export default component.exports